import React from 'react';
import { View, Text, Image, StyleSheet } from '@react-pdf/renderer';
import { colors, typography, spacing } from '../styles/theme';

const styles = StyleSheet.create({
  container: {
    backgroundColor: colors.background.section,
    borderLeftWidth: 4,
    borderLeftColor: colors.primary,
    borderLeftStyle: 'solid',
    padding: spacing.md,
    marginBottom: spacing.md,
    flexDirection: 'row',
    alignItems: 'center',
  },
  iconContainer: {
    width: 50,
    height: 50,
    marginRight: spacing.md,
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    width: 40,
    height: 40,
  },
  content: {
    flex: 1,
  },
  value: {
    ...typography.metric,
    marginBottom: spacing.xs,
  },
  label: {
    ...typography.metricLabel,
    marginBottom: spacing.xs,
  },
  description: {
    ...typography.caption,
  },
  // Variant: compact
  containerCompact: {
    padding: spacing.sm,
    marginBottom: spacing.sm,
  },
  valueCompact: {
    fontSize: 24,
    fontWeight: 'bold',
    color: colors.primary,
    marginBottom: 2,
  },
  labelCompact: {
    fontSize: 9,
    fontWeight: 'semibold',
    color: colors.text.primary,
    textTransform: 'uppercase',
  },
  iconCompact: {
    width: 30,
    height: 30,
  },
  iconContainerCompact: {
    width: 40,
    height: 40,
    marginRight: spacing.sm,
  },
});

const MetricCard = ({
  value,
  label,
  description,
  icon,
  variant = 'default',
  accentColor,
}) => {
  const isCompact = variant === 'compact';
  const borderColor = accentColor || colors.primary;

  return (
    <View
      style={[
        styles.container,
        isCompact && styles.containerCompact,
        { borderLeftColor: borderColor },
      ]}
    >
      {icon && (
        <View
          style={isCompact ? styles.iconContainerCompact : styles.iconContainer}
        >
          <Image
            style={isCompact ? styles.iconCompact : styles.icon}
            src={icon}
          />
        </View>
      )}
      <View style={styles.content}>
        <Text style={isCompact ? styles.valueCompact : styles.value}>
          {value}
        </Text>
        <Text style={isCompact ? styles.labelCompact : styles.label}>
          {label}
        </Text>
        {description && !isCompact && (
          <Text style={styles.description}>{description}</Text>
        )}
      </View>
    </View>
  );
};

export default MetricCard;
